import OfferList from "./OfferList";
import OfferShow from "./OfferShow";
import OfferEdit from "./OfferEdit";
import OfferCreate from "./OfferCreate";

export default {
  list: OfferList,
  show: OfferShow,
  edit: OfferEdit,
  create: OfferCreate,
};
